import styled from 'styled-components';

import { media } from '../../../styles/constants';

const TabletAndPhoneContainer = styled.div`
  display: flex;

  position: relative;
  margin-top: 3rem;
  justify-content: center;
  margin-bottom: 17rem;

  img {
    width: 100%;
    height: auto;
  }

  > div:first-child {
    width: 100%;
    min-width: 43rem;
    margin-left: 10rem;
  }

  > div:last-child {
    position: absolute;
    width: 100%;
    left: -4rem;
    bottom: -55%;
    max-width: 58rem;
    min-width: 40rem;
  }

  @media (min-width: ${media.phone}) {
    margin-top: 2rem;
  }

  @media (min-width: ${media.tabletPortrait}) {
    margin-top: 4rem;
    margin-bottom: 25rem;

    > div:first-child {
      margin-left: 18rem;
      min-width: 70rem;
    }

    > div:last-child {
      bottom: -43%;
    }
  }

  @media (min-width: ${media.tabletLandscape}) {
    margin-top: 0rem;
    justify-content: initial;
    margin-bottom: 7rem;

    > div:first-child {
      width: 78%;
      margin-left: 4.5rem;
      margin-top: 7rem;
    }

    > div:last-child {
      width: 58%;
      left: auto;
      bottom: auto;
      right: -14rem;
      top: -18rem;
    }
  }

  @media (min-width: ${media.desktop}) {
    margin-top: 0;

    > div:first-child {
      width: 86%;
      margin-top: 3rem;
    }

    > div:last-child {
      width: 62%;
      right: -35rem;
      top: -10rem;
    }
  }

  @media (min-width: ${media.bigDesktop}) {
    margin-top: 5rem;

    > div:first-child {
      width: 90%;
      margin-top: 3rem;
    }

    > div:last-child {
      width: 100%;
      right: -45rem;
      top: -15rem;
    }
  }
`;

export default TabletAndPhoneContainer;
